import React, { Component } from 'react';
import { getStoresListPaginate, removeStoreItem } from '../../modules/Api';
import ReactTable from 'react-table'
import history from '../../modules/History';
import { END_POINT } from '../../constants/config';
import { Button, notification } from 'antd';
import ACL from '../../components/ACL';

class Stores extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }
    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getStoresListPaginate(query, (data) => {this.setState({
            items: data.data,
            count: data.total,
            last_page: data.last_page,
            pageSize: data.per_page
        })});
        //getStoresCount(``, (count) => {this.setState({count})});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        const id = state.filtered.find(f => f.id === 'id') ? state.filtered.find(f => f.id === 'id').value : '';
        const name = state.filtered.find(f => f.id === 'name') ? state.filtered.find(f => f.id === 'name').value : '';
        const website = state.filtered.find(f => f.id === 'website') ? state.filtered.find(f => f.id === 'website').value : '';
        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&name=${name}&website=${website}&id=${id}`

        this.fetchData(query);
    }

    removeStore(id) {
        const warningMessage = `آیا از حذف فروشگاه اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            removeStoreItem(id, () => {
                this.fetchData();
                notification.open({
                    message: `فروشگاه با موفقیت حذف شد!`,
                    description: `تمامی اطلاعات فروشگاه و قرعه کشی های آن با موفقیت حذف شدند.`
                })
            })
        }
    }
    render() {
        const columns = [
            {
                Header: 'آیدی',
                filterable: true,
                sortable: true,
                accessor: 'id',
            },
            {
                Header: 'لوگو',
                Cell: row => (row.original.logo && <img src={`${row.original.logo.includes('http') ? row.original.logo : END_POINT + row.original.logo}`} style={{width: '50px', height: '50px'}} alt={row.original.name}/>)
            },
            {
                filterable: true,
                Header: 'نام',
                accessor: 'name',
                sortable: true,
                Cell: (row) => (<ACL component="span" has_permission="stores_edit|stores_management" denied={() => {return row.original.name;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.description} onClick={() => {window.open(`/stores/edit/${row.original.id}`, "_blank");}}> {row.original.name} </span></ACL>)
            },
            {
                Header: 'URL',
                accessor: 'slug',
                Cell: (row) => (<span> {row.original.slug} </span>)
            },
            {
                Header: 'وب سایت',
                accessor: 'website',
                filterable: true,
                Cell: (row) => (<a href={row.original.website} target="_blank"> {row.original.website} </a>)
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="stores_delete|stores_management"><span onClick={() => {this.removeStore(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="stores_history|stores_management"><span onClick={() => history.item.push(`/history/brand/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div className="btn-container">
                    <ACL component="div" has_permission="stores_add|stores_management"><Button type="primary" onClick={() => history.item.push(`/stores/add`)}>افزودن فروشگاه جدید</Button></ACL>
                    <ACL component="div" has_permission="stores_history|stores_management"><Button type="secondary" onClick={() => history.item.push(`/history/brand`)}>تاریخچه تغییرات</Button></ACL>
                </div>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={15}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Stores;


// WEBPACK FOOTER //
// ./src/containers/Stores/index.js